import React from "react";
import { useSearchParams } from "react-router-dom";
import PatientEnrolmentBookEyeCheckHeading from "./PatientEnrolmentBookEyeCheckHeading";
import PatientEnrolmentBookEyeCheckStepOne from "./PatientEnrolmentBookEyeCheckStepOne";
import PatientEnrolmentBookEyeCheckStepTwo from "./PatientEnrolmentBookEyeCheckStepTwo";
import PortableView from "./PortableView";
import axios from "axios";
import { InvalidQueryParameters } from "../../services/errors";

type Props = {
  csrfToken: string;
};

type State = {
  showEmailField: boolean;
  email: string;
  inFlight: boolean;
  sendEmailSuccess: string;
  sendEmailError: string;
};

const PatientEnrolmentBookEyeCheck = (props: Props) => {
  const [params] = useSearchParams();

  const patientName = params.get("patientName");
  const email = params.get("email") || "";
  const ndssNumber = params.get("ndssNumber");
  const lastEyeCheck = params.get("lastEyeCheck");
  const patientEnrolmentUuid = params.get("patientEnrolmentUuid");

  if (!patientName || !lastEyeCheck || !patientEnrolmentUuid) {
    throw new InvalidQueryParameters(
      "Missing required parameters for page to render correctly",
    );
  }

  const [state, setState] = React.useState<State>({
    showEmailField: false,
    email,
    inFlight: false,
    sendEmailSuccess: "",
    sendEmailError: "",
  });

  const showEmailFieldOnClick = () => {
    setState({ ...state, showEmailField: true });
  };

  const showPrintView = () => {
    window.print();
  };

  const sendEmail = async () => {
    if (state.inFlight) {
      return;
    } else {
      setState({
        ...state,
        inFlight: true,
        sendEmailError: "",
        sendEmailSuccess: "",
      });
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": props.csrfToken,
      },
    };

    const params = {
      email_address: state.email,
      patient_enrolment_uuid: patientEnrolmentUuid,
    };

    const {
      data: { message },
    } = await axios.post("/visit_cards/email", params, config);

    setState({ ...state, sendEmailSuccess: message, inFlight: false });
  };

  const emailOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, email: event.target.value.trim() });
  };

  return (
    <div className="content-page">
      <div id="patient-enrolment-book-eye-check-web-view">
        <PatientEnrolmentBookEyeCheckHeading />

        <PatientEnrolmentBookEyeCheckStepOne
          showPrintView={showPrintView}
          showEmailFieldOnClick={showEmailFieldOnClick}
          showEmailField={state.showEmailField}
          email={state.email}
          emailOnChange={emailOnChange}
          sendEmail={sendEmail}
          sendEmailSuccess={state.sendEmailSuccess}
          sendEmailError={state.sendEmailError}
        />

        <PatientEnrolmentBookEyeCheckStepTwo />
      </div>

      <PortableView
        patientName={patientName}
        ndssNumber={ndssNumber}
        lastEyeCheck={lastEyeCheck}
      />
    </div>
  );
};

export default PatientEnrolmentBookEyeCheck;
